import { combineReducers } from 'redux';

import { kioskReducer } from './containers/Kiosk/services/reducers';

export const kioskModuleReducer = combineReducers({
  kioskReducer,
});

export type KioskModuleState = ReturnType<typeof kioskModuleReducer>;
